import React, { useState } from "react";
import ButtonArrow from "../components/ButtonArrow";
import Us from "./Us";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import { Link } from "react-router-dom";
import Accomodation from "../components/Accomodation";
import GastronomicVenue from "../components/GastronomicVenue";
import Activity from "../components/Activity";
import Entrepreneur from "../components/Entrepreneur";
import carnavalImage from "../Images/carnaval.webp";
import galleryImage from "../Images/gallery.png";
import logo from "../Images/logo.png";
import protectedAreaImage from "../Images/area_protegida_vertical.jpg";
import VidaLitoral from "./VidaLitoral";
import CarouselComponent from "../components/CarouselComponent";
import EventCard from "../components/EventCard";
import MultiCarousel from "react-multi-carousel";
import { Carousel } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import { API_URL } from "../Helpers/api";
import Artigas from "../components/Artigas";
import shuffleArray from "../Helpers/ShuffleArray";
import { Helmet } from "react-helmet";
import CamaraTurismo from "../components/CamaraTurismo";

const Home = () => {
  const [accomodations, setAccomodations] = useState();
  const [gastronomy, setGastronomy] = useState();
  const [activities, setActivities] = useState();
  const [entrepreneurs, setEntrepreneurs] = useState();
  const [events, setEvents] = useState();
  const [itemsPerSlide, setItemsPerSlide] = useState(3);
  const [groupedEvents, setGroupedEvents] = useState();

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3, slidesToSlide: 1, cardWidth: "350px" },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2, slidesToSlide: 1, cardWidth: "350px" },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1, cardWidth: "80vw" },
  };

  useEffect(() => {
    const scrollContainer = document.querySelector(".scroll-menu-wrapper");
    const interval = setInterval(() => {
      scrollContainer?.scrollBy({ left: 1, behavior: "smooth" });
    }, 20);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/accomodation`))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setAccomodations(shuffledAdds);
        } else {
          console.warn("No acomodation adds found");
        }
      })
      .catch((err) => console.error(err.message));

    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/gastronomic`))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setGastronomy(shuffledAdds);
        } else {
          console.warn("No grastronomy adds found");
        }
      })
      .catch((err) => console.error(err.message));

    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/activity`))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setActivities(shuffledAdds);
        } else {
          console.warn("No activitiy adds found");
        }
      })
      .catch((err) => console.error(err.message));

    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/entrepreneur`))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setEntrepreneurs(shuffledAdds);
        } else {
          console.warn("No entrepreneur adds found");
        }
      })
      .catch((err) => console.error(err.message));

    axios(axiosConfig("GET", `${API_URL}/events/get-active`))
      .then((res) => {
        if (res.data.success) {
          setEvents(res.data.events);
        } else {
          console.warn("No events found");
        }
      })
      .catch((err) => console.error(err.message));
  }, []);

  useEffect(() => {
    const updateItemsPerSlide = () => {
      if (window.innerWidth >= 1400)
        setItemsPerSlide(4); // xxl
      else if (window.innerWidth >= 992)
        setItemsPerSlide(3); // lg
      else if (window.innerWidth >= 768)
        setItemsPerSlide(2); // md
      else setItemsPerSlide(1); // sm
    };
    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);
    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  useEffect(() => {
    if (events?.length > 0) {
      const chunks = [];
      for (let i = 0; i < events.length; i += itemsPerSlide) {
        chunks.push(events.slice(i, i + itemsPerSlide));
      }
      setGroupedEvents(chunks);
    }
  }, [events, itemsPerSlide]);

  // console.log(groupedEvents);

  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Bella Unión – Turismo, Cultura y Experiencias Únicas</title>
        <meta
          name="description"
          content="Bella Unión: descubre experiencias únicas en nuestra región, con alojamiento, gastronomía, actividades y cultura en un solo lugar."
        />
        <meta
          name="keywords"
          content="Bella Unión, turismo Bella Unión, alojamiento Bella Unión, gastronomía Bella Unión, actividades Bella Unión, carnaval Bella Unión"
        />
        <link rel="canonical" href="https://bellaunion.uy" />
        <meta property="og:title" content="Bella Unión – Turismo, Cultura y Experiencias Únicas" />
        <meta
          property="og:description"
          content="Bella Unión: descubre experiencias únicas en nuestra región, con alojamiento, gastronomía, actividades y cultura en un solo lugar."
        />
        <meta property="og:url" content="https://bellaunion.uy" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={logo} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="robots" content="index, follow" />
        <meta name="twitter:title" content="Bella Unión – Turismo, Cultura y Experiencias Únicas" />
        <meta
          name="twitter:description"
          content="Bella Unión: descubre experiencias únicas en nuestra región, con alojamiento, gastronomía, actividades y cultura en un solo lugar."
        />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Bienvenidos a Bella Unión</h1>
        <span className="d-block text-center text-light fs-5">La triple frontera más austral del mundo</span>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light mx-auto" id="main-container" style={{ marginTop: "100vh" }}>
        {events?.length > 0 && (
          <div className="container text-center py-5">
            <h2 className="mb-5">Próximos Eventos</h2>
            <>
              <MultiCarousel
                arrows={false}
                className="row g-4 d-md-block d-none"
                responsive={responsive}
                autoPlay={false}
                infinite
              >
                {events?.length > 100 &&
                  events.map((event, i) => (
                    // <Carousel.Item className="col-4">
                    <EventCard event={event} key={event._id} cardWidth={null} />
                    // </Carousel.Item>
                  ))}
              </MultiCarousel>
              <Carousel
                interval={300000000}
                // data-bs-theme="dark"
                controls={groupedEvents?.length > 1 ? true : false}
              >
                {groupedEvents?.map((group, idx) => (
                  <Carousel.Item key={idx}>
                    <div className="row g-3 justify-content-center">
                      {group.map((event, j) => (
                        <div
                          className={`col-${12 / itemsPerSlide} justify-content-center d-flex`}
                          key={event._id}
                        >
                          <EventCard event={event} />
                        </div>
                      ))}
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </>
          </div>
        )}
        <Us />
        <div className="container-fluid mt-5">
          <h2 className="text-center">Alojamiento. Descanso y Confort para tu Viaje</h2>
          <p className="text-center mx-auto" style={{ maxWidth: "600px" }}>
            La región ofrece una amplia variedad de alojamientos diseñados para satisfacer distintos gustos y
            necesidades. Desde hoteles con todas las comodidades hasta experiencias más inmersivas en la
            naturaleza, aquí encontrarás el lugar ideal para tu estadía.
          </p>
          {accomodations?.length > 0 ? (
            <>
              <div className="row">
                {accomodations?.map((accomodation, i) => {
                  if (i < 2) {
                    return (
                      <div className="col-xxl-6 d-flex align-items-center">
                        <div className="row g-0 py-5 justify-content-center">
                          <Accomodation data={accomodation} index={i} key={accomodation._id} />
                        </div>
                      </div>
                    );
                  }
                })}
                <div className="text-end">
                  <Link to={"/alojamiento"} className="btn btn-lg btn-success px-4 rounded-pill shadow">
                    <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                    Ver más alojamientos
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <p className="fs-2 fw-light text-center">No se encontraron alojamientos</p>
          )}
          <hr className="my-5" />
          <div className="row">
            <div className="col-xxl-6">
              <h2 className="text-center">Gastronomía</h2>
              {gastronomy?.length > 0 ? (
                <>
                  <div className="row py-5 align-items-stretch g-3 d-flex align-items-center">
                    {gastronomy.map((venue, i) => {
                      if (i < 2) {
                        return <GastronomicVenue data={venue} key={venue._id} />;
                      }
                    })}
                  </div>
                  <div className="text-end">
                    <Link to={"/gastronomia"} className="btn btn-lg btn-success px-4 rounded-pill shadow">
                      <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                      Ver más locales
                    </Link>
                  </div>
                </>
              ) : (
                <p className="fs-2 fw-light text-center">No se encontraron locales gastronómicos</p>
              )}
            </div>
            <hr className="my-5 d-xxl-none d-block" />
            <div className="col-xxl-6">
              <h2 className="text-center">Actividades</h2>
              {activities?.length > 0 ? (
                <>
                  <div className="row py-5 align-items-stretch g-3 d-flex align-items-center">
                    {activities.map((activity, i) => {
                      if (i < 2) {
                        return <Activity data={activity} index={i} key={activity._id} />;
                      }
                    })}
                  </div>
                  <div className="text-end">
                    <Link to={"/actividades"} className="btn btn-lg btn-success px-4 rounded-pill shadow">
                      <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                      Ver más actividades
                    </Link>
                  </div>
                </>
              ) : (
                <p className="fs-2 fw-light text-center">No se encontraron actividades</p>
              )}
            </div>
          </div>
          <hr className="my-5" />
          <h2 className="text-center">Emprendedores</h2>
          <div className="row g-4 justify-content-center">
            {entrepreneurs?.length > 0 ? (
              <>
                {/* <div className="row"> */}
                {entrepreneurs?.map((entrepreneur, i) => {
                  if (i < 2) {
                    return (
                      <div className="col-xxl-6 d-flex align-items-center">
                        {/* <div className="row g-0 py-5 justify-content-center"> */}
                        <Entrepreneur data={entrepreneur} index={i} key={entrepreneur._id} />
                        {/* </div> */}
                      </div>
                    );
                  }
                })}
                <div className="text-end">
                  <Link to={"/emprendimientos"} className="btn btn-lg btn-success px-4 rounded-pill shadow">
                    <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                    Ver más emprendedores
                  </Link>
                </div>
                {/* </div> */}
              </>
            ) : (
              <p className="fs-2 fw-light text-center">No se encontraron emprendedores</p>
            )}
          </div>
        </div>
        <div className="position-relative filter-dark">
          <div className="container-fluid mt-5" style={{ maxWidth: 1600 }}>
            <div className="row g-0">
              <div className="col-md-4">
                <Link to="/carnaval" className="text-decoration-none">
                  <div
                    className="add-img d-flex align-items-center justify-content-center"
                    style={{ backgroundImage: `url(${carnavalImage})`, aspectRatio: "4 / 5" }}
                  >
                    <div className="d-flex top-0 w-100 h-100 align-items-center justify-content-center filter-dark">
                      <h2 className="fs-1 text-light text-center fw-light">
                        Nuestro <br /> Carnaval
                      </h2>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-md-4 position-relative">
                <Link to={"/galeria"}>
                  <div
                    className="add-img"
                    style={{ backgroundImage: `url(${galleryImage})`, aspectRatio: "4 / 5" }}
                  ></div>
                  {/* <img src={galleryImage} alt="" className="w-100" /> */}
                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex">
                    <div className="d-flex top-0 w-100 h-100 align-items-center justify-content-center filter-dark">
                      <h2 className="fs-1 text-light text-center m-auto fw-light">
                        Galería
                        <br />
                        de fotos
                      </h2>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-md-4 position-relative">
                <Link to={"/area-protegida"}>
                  <div
                    className="add-img"
                    style={{ backgroundImage: `url(${protectedAreaImage})`, aspectRatio: "4 / 5" }}
                  ></div>
                  {/* <img src={protectedAreaImage} alt="" className="w-100" /> */}
                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex">
                    <div className="d-flex top-0 w-100 h-100 align-items-center justify-content-center filter-dark">
                      <h2 className="fs-1 text-light text-center m-auto fw-light">
                        Área
                        <br />
                        Protegida
                      </h2>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          {/* <div className="position-absolute top-0 w-100 h-100 filter-dark"></div> */}
        </div>
        <div className="my-5">
          <Artigas />
        </div>
        <VidaLitoral />
        <CamaraTurismo />
      </div>
    </main>
  );
};

export default Home;
